var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('slideBox'),_c('itemList'),_c('footerLinks'),_c('footerBar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }